<template>
    <div class="main-container">
        <h1>Edit account</h1>
        <form>
            <h2>Basic info</h2>
            <div class="name-row">
                <v-text-field class="first-name" label="First name" v-model="user.firstName" @blur="validateFirstName()" :error-messages="this.userErrors.firstNameErrors" outlined solo flat :height="50" color="#18125a"></v-text-field>
                <v-text-field label="Last name" v-model="user.lastName" @blur="validateLastName()" :error-messages="this.userErrors.lastNameErrors" outlined solo flat :height="50" color="#18125a"></v-text-field>
            </div>
            <v-text-field
                label="Email"
                type="email"
                v-model="user.email"
                @blur="validateEmail()"
                :error-messages="userErrors.emailErrors"
                outlined
                solo
                flat
                :height="50"
                color="#18125a"
            ></v-text-field>
            <h2>Credentials</h2>
            <v-text-field
                label="Current password"
                type="password"
                v-model="user.password"
                outlined
                solo
                flat
                :height="50"
                color="#18125a"
            ></v-text-field>
            <v-text-field
                label="New password"
                type="password"
                v-model="user.newPassword"
                @blur="validatePasswordConfirmation()"
                outlined
                solo
                flat
                :height="50"
                color="#18125a"
            ></v-text-field>
            <v-text-field
                label="Confirm password"
                type="password"
                v-model="user.passwordConfirmation"
                @blur="validatePasswordConfirmation()"
                :error-messages="userErrors.passwordConfErrors"
                outlined
                solo
                flat
                :height="50"
                color="#18125a"
            ></v-text-field>
            <span>
                <button type="button" @click="validateForm">Update account</button>
            </span>
        </form>
    </div>
</template>

<script>
import store from '@/services/business/store';

export default {
    name: 'EditAccountComponent',
    data: () => {
        return {
            user: {
				firstName: window.localStorage.getItem('userFirst'),
				lastName: window.localStorage.getItem('userLast'),
				email: window.localStorage.getItem('userEmail'),
                password: null,
                passwordConfirmation: null,
                newPassword: null
			},
			userErrors: {
				firstNameErrors: [],
				lastNameErrors: [],
                emailErrors: [],
                passwordErrors: [],
                passwordConfErrors: []
			},
        }
    },
    methods: {
        validateForm() {
			if (this.validateEmail() & this.validateLastName() & this.validateFirstName() & this.validatePasswordConfirmation()) {
                store.updateAccount(
                    this.user.email,
                    this.user.firstName,
                    this.user.lastName,
                    this.user.password,
                    this.user.newPassword,
                    this.user.passwordConfirmation
                );
			}
		},
		validateFirstName() {
			this.userErrors.firstNameErrors = [];
			if (!this.user.firstName) {
				this.userErrors.firstNameErrors.push('Your first name is required');
			}
			return !this.userErrors.firstNameErrors.length > 0;
		},
		validateLastName() {
			this.userErrors.lastNameErrors = [];
			if (!this.user.lastName) {
				this.userErrors.lastNameErrors.push('Your last name is required');
			}
			return !this.userErrors.lastNameErrors.length > 0;
		},
		validateEmail() {
			this.userErrors.emailErrors = [];
			if (!this.user.email) {
				this.userErrors.emailErrors.push('Your email is required');
			}
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(String(this.user.email).toLowerCase())) {
				this.userErrors.emailErrors.push('Invalid email');
			}
			return !this.userErrors.emailErrors.length > 0;
		},
		validatePasswordConfirmation() {
            this.userErrors.passwordConfErrors = [];
            if (this.user.passwordConfirmation != this.user.newPassword) {
                this.userErrors.passwordConfErrors.push('The password confirmation must match the new password');
            }
			return !this.userErrors.passwordErrors.length > 0;
		},
    }
};
</script>

<style lang="scss" scoped>
    .main-container {
        display: flex;
        flex-direction: column;

        h1 {
            font-size: 3rem;
            color: #18125a;
            text-align: center;
            margin-top: 40px;
            margin-bottom: 20px;
        }

        form {
            display: flex;
            flex-direction: column;
            width: 50%;
            max-width: 425px;
            align-self: center;
            justify-self: center;

            .name-row {
                display: flex;
                flex-direction: row;

                .first-name {
                    margin-right: 25px;
                }
            }

            button {
                background: #e79831;
                color: white;
                font-weight: bold;
                width: 100%;
                height: 50px;
                padding: 5px;
                border-radius: 5px;
                font-size: 1.2rem;
            }
        }    
    }

    @media screen and (max-width: 600px) {
		.main-container {
            padding: 20px;

            form {
                width: 100%;
            }
		}
	}
</style>